import router from '../router';
import {store} from '../vuex/store';

export const clear_invalid_token = () => {
	store.commit('hide_loading_modal');
	store.commit('remove_user');
	router.push('/authenticate/log-in');
};
